import { capitalize } from 'src/utils/capitalize';

export const formatRoleNameCapitalized = (role: string): string =>
  capitalize(role).replace('_', ' ');
export const formatRoleName = (role: string): string =>
  role.replace('_', ' ').toLowerCase();
